export default __webpack_public_path__ + "static/media/GustavGroundHitParticle.6d782f44.png";